module.exports = __webpack_public_path__ + "img/logo-UMCP.4bc9803a.svg";